import React, { Fragment } from 'react';
import { RectShape, RoundShape, TextBlock, TextRow } from '@thd-olt-component-react/loading-placeholder';

export const EtchPlaceholder = () => (
  <TextBlock color="#E0E0E0" rows={12} />
);
